export class CodeBlockSectionModel {
    name = 'New Section';
    description: '';
    toggled = true;
    hovered = false;
    clicked = false;
    blocks = [];
}